// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 847) return "static/chunks/a18f0e56-272654971375ac56.js";
	if (chunkId === 336) return "static/chunks/336-b7a90f576ff32bcb.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"c52e836da5250660","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"99bf2dc842cd9bfe","367":"ad5e01f9c0b1fda0","639":"33a3c48de1a14c41","748":"8cb8654976837a0b"}[chunkId] + ".js";
};